export default "__VITE_ASSET__DmZrueQM__"